import $ from "jquery";
// (function(DJG) {
//     // private methods 
//     function function_name (argument) {
//     }
//     // public methods 
//     DJG.foo = {
//         
//     };
//     
// })(DJG);
$(function() {
  $("[data-gaevent-category]").on('click', function(ev){
    var t = $(ev.currentTarget);
    var category = t.data('gaevent-category') || "";
    var action =   t.data('gaevent-action') || "";
    var label =    t.data('gaevent-label') || "";
    try {
       ga('send', 'event', category, action, label); 
    } catch(e){};
  });
});
// $('#nav_scrollspy').on('activate.bs.scrollspy', function () {
//     $(this).find('a').blur();
// });
